<div class="card">
  <div class="card-header flex-between">
    <h5>Security Groups</h5>
    <div class="flex-start">
      <button class="btn btn-light" (click)="load()">
        <span>
          Refresh
        </span>
      </button>
      <button class="btn btn-primary-soft" (click)="createJob($event)" *ngIf="jobProgress != 'In Progress'">
        <span>
          Scan
        </span>
      </button>
    </div>
  </div>
  <div class="card-body" *ngIf="jobProgress == 'In Progress'">
    <div class="job-progress flex-between">
      <span class="inherit">
        Scan is in Progress. Please wait
      </span>
      <img src="../assets/img/loading_2.svg" alt="loading scans" class="width18" />

    </div>
  </div>
  <div class="card-body" *ngIf="jobProgress != 'In Progress'">
    <nav>
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <button *ngFor="let tab of sgTabs; let i = index" class="nav-link" [ngClass]="{'active' : i == 0}"
          id="nav-home-tab" [attr.data-bs-toggle]="'tab'" [attr.data-bs-target]="tab.metadata.id_str" type="button"
          role="tab" [attr.aria-controls]="tab.onclick" (click)="getSecurityGroups(tab.onclick)" aria-selected="true"
          [innerHTML]="tab.metadata.str">
        </button>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div *ngFor="let tab of sgTabs; let i = index" class="tab-pane " [ngClass]="{'active' : i == 0}"
        id={{tab.onclick}} role="tabpanel" [attr.aria-labelledby]="tab.onclick+'-tab'">
        <table class="table table-docs table-hover">
          <thead>
            <tr>
              <th>S.N.</th>
              <th *ngFor="let h of headers">
                {{ h.name }}
                <span *ngIf="h.sort && h.sort.sort" (click)="notifier.sortTable(h,sgList)">

                  <i class="fa fa-sort-amount-desc" aria-hidden="true" *ngIf="h.sort.direction == 'Des'"></i>
                  <i class="fa fa-sort-amount-asc" aria-hidden="true" *ngIf="h.sort.direction == 'Asc'"></i>
                </span>

                <span *ngIf="h.filter " class="inputseach">
                  <input autocomplete="off" type="text" [(ngModel)]="h.filterText" />
                  <i class="fa fa-search" aria-hidden="true"></i>
                </span>
              </th>
              <th *ngIf="writeAccess">Actions</th>
            </tr>
          </thead>
          <tbody [ngStyle]="{'display': sgList.length > 0 ? 'table-row-group' : 'none'}"
            *ngFor="let i of sgList; let j = index">
            <tr *ngIf="notifier.filterTableColums(headers,i)">
              <td> <i *ngIf="!i.showNested" class="fa fa-caret-right"></i> <i *ngIf="i.showNested"
                  class="fa fa-caret-down"></i> {{ j + 1 }}</td>
              <td *ngFor="let h of headers">
                <span *ngIf="h.click" class="btn" (click)="callFunction(h.click, i)">
                  <span>
                    {{ i[h.id] }}
                  </span>
                </span>
                <span *ngIf="!h.click">
                  {{ i[h.id] }}
                </span>
              </td>
              <td *ngIf="writeAccess">
                <button type="button" class="btn btn-light btn-sm" (click)="openRulesModal(i)">
                  Manage Rules
                </button>
              </td>
            </tr>
            <tr *ngIf="i.showNested" class="shownested-height">
              <td [attr.colspan]="headers.length + (writeAccess ? 2 : 1)">
                <nTable [headers]="attachedInstancesHeader" [data]="i.attachedInstances"
                  (hideModal)="hideNested($event)"></nTable>
              </td>
            </tr>
          </tbody>
          <tbody *ngIf="sgList.length == 0">
            <tr>
              <td [attr.colspan]="headers.length + (writeAccess ? 2 : 1)">
                <div class="No-sg-found">No Security Groups Found</div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<sg-create-job-element *ngIf="createJobTrigger" (hideModal)="hideCreateJob($event)">
</sg-create-job-element>

<div *ngIf="rulesModalOpen" class="rules-modal-backdrop">
  <div class="rules-modal">
    <div class="rules-modal__header">
      <div>
        <div class="rules-modal__title">Manage Security Group Rules</div>
        <div class="rules-modal__subtitle">
          {{ selectedSecurityGroup?.sg_name || "-" }} ({{ selectedSecurityGroup?.sg_id || "-" }})
        </div>
      </div>
      <button type="button" class="rules-modal__close" [disabled]="rulesSaving" (click)="closeRulesModal()">
        <i class="fa fa-times"></i>
      </button>
    </div>

    <div class="rules-modal__body">
      <div class="rules-tabs">
        <button
          type="button"
          class="rules-tab-btn"
          [ngClass]="{ 'rules-tab-btn--active': rulesActiveTab === 'inbound' }"
          (click)="setRulesTab('inbound')"
        >
          Inbound Rules
        </button>
        <button
          type="button"
          class="rules-tab-btn"
          [ngClass]="{ 'rules-tab-btn--active': rulesActiveTab === 'outbound' }"
          (click)="setRulesTab('outbound')"
        >
          Outbound Rules
        </button>
      </div>

      <div *ngIf="rulesLoading" class="rules-loading-state">
        Loading rules...
      </div>

      <ng-container *ngIf="!rulesLoading">
        <div class="rules-toolbar">
          <button
            type="button"
            class="btn btn-light btn-sm"
            (click)="addRule(rulesActiveTab)"
          >
            <i class="fa fa-plus"></i> Add Rule
          </button>
          <span *ngIf="!rulesFetchSupported" class="rules-note">
            Existing rules could not be loaded, but you can still submit add/revoke changes manually.
          </span>
        </div>

        <div class="rules-table-wrap" *ngIf="rulesActiveTab === 'inbound'">
          <table class="table table-bordered rules-table">
            <thead>
              <tr>
                <th>Protocol</th>
                <th>From Port</th>
                <th>To Port</th>
                <th>Source Type</th>
                <th>Source</th>
                <th class="rules-action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rule of inboundRules" [ngClass]="{ 'rule-new-row': rule.isNew }">
                <td>
                  <select class="form-select" [(ngModel)]="rule.protocol">
                    <option value="tcp">TCP</option>
                    <option value="udp">UDP</option>
                    <option value="icmp">ICMP</option>
                    <option value="icmpv6">ICMPv6</option>
                    <option value="-1">All Traffic</option>
                  </select>
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="rule.from_port"
                    [disabled]="!usesPortRange(rule.protocol)"
                    [ngClass]="{
                      'rule-invalid': rulesSubmitAttempted && !isRuleRowValid(rule)
                    }"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="rule.to_port"
                    [disabled]="!usesPortRange(rule.protocol)"
                    [ngClass]="{
                      'rule-invalid': rulesSubmitAttempted && !isRuleRowValid(rule)
                    }"
                  />
                </td>
                <td>
                  <select class="form-select" [(ngModel)]="rule.target_type">
                    <option value="cidr_ipv4">CIDR IPv4</option>
                    <option value="cidr_ipv6">CIDR IPv6</option>
                    <option value="referenced_group_ids">Security Group</option>
                    <option value="prefix_list_ids">Prefix List</option>
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="rule.target_value"
                    [placeholder]="
                      rule.target_type === 'cidr_ipv4'
                        ? '0.0.0.0/0'
                        : rule.target_type === 'cidr_ipv6'
                        ? '::/0'
                        : rule.target_type === 'referenced_group_ids'
                        ? 'sg-xxxxxxxx'
                        : 'pl-xxxxxxxx'
                    "
                    [ngClass]="{
                      'rule-invalid': rulesSubmitAttempted && !isRuleRowValid(rule)
                    }"
                  />
                  <div *ngIf="rulesSubmitAttempted && !isRuleRowValid(rule)" class="rule-error-text">
                    {{ getRuleValidationMessage(rule) }}
                  </div>
                </td>
                <td class="rules-action-col">
                  <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeRule('inbound', rule)">
                    Remove
                  </button>
                </td>
              </tr>
              <tr *ngIf="inboundRules.length === 0">
                <td colspan="6" class="rules-empty-state">No inbound rules configured.</td>
              </tr>
            </tbody>
          </table>

          <div *ngIf="revokeInboundRules.length" class="rules-revoke-section">
            <div class="rules-revoke-section__title">Queued for Revocation</div>
            <table class="table table-bordered rules-table">
              <thead>
                <tr>
                  <th>Protocol</th>
                  <th>From Port</th>
                  <th>To Port</th>
                  <th>Source Type</th>
                  <th>Source</th>
                  <th class="rules-action-col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rule of revokeInboundRules" class="rule-revoke-row">
                  <td>{{ rule.protocol }}</td>
                  <td>{{ rule.from_port ?? "-" }}</td>
                  <td>{{ rule.to_port ?? "-" }}</td>
                  <td>{{ rule.target_type }}</td>
                  <td>{{ rule.target_value || "-" }}</td>
                  <td class="rules-action-col">
                    <button type="button" class="btn btn-light btn-sm" (click)="undoRemoveRule('inbound', rule)">
                      Undo
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="rules-table-wrap" *ngIf="rulesActiveTab === 'outbound'">
          <table class="table table-bordered rules-table">
            <thead>
              <tr>
                <th>Protocol</th>
                <th>From Port</th>
                <th>To Port</th>
                <th>Destination Type</th>
                <th>Destination</th>
                <th class="rules-action-col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rule of outboundRules" [ngClass]="{ 'rule-new-row': rule.isNew }">
                <td>
                  <select class="form-select" [(ngModel)]="rule.protocol">
                    <option value="tcp">TCP</option>
                    <option value="udp">UDP</option>
                    <option value="icmp">ICMP</option>
                    <option value="icmpv6">ICMPv6</option>
                    <option value="-1">All Traffic</option>
                  </select>
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="rule.from_port"
                    [disabled]="!usesPortRange(rule.protocol)"
                    [ngClass]="{
                      'rule-invalid': rulesSubmitAttempted && !isRuleRowValid(rule)
                    }"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    class="form-control"
                    [(ngModel)]="rule.to_port"
                    [disabled]="!usesPortRange(rule.protocol)"
                    [ngClass]="{
                      'rule-invalid': rulesSubmitAttempted && !isRuleRowValid(rule)
                    }"
                  />
                </td>
                <td>
                  <select class="form-select" [(ngModel)]="rule.target_type">
                    <option value="cidr_ipv4">CIDR IPv4</option>
                    <option value="cidr_ipv6">CIDR IPv6</option>
                    <option value="referenced_group_ids">Security Group</option>
                    <option value="prefix_list_ids">Prefix List</option>
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    class="form-control"
                    [(ngModel)]="rule.target_value"
                    [placeholder]="
                      rule.target_type === 'cidr_ipv4'
                        ? '0.0.0.0/0'
                        : rule.target_type === 'cidr_ipv6'
                        ? '::/0'
                        : rule.target_type === 'referenced_group_ids'
                        ? 'sg-xxxxxxxx'
                        : 'pl-xxxxxxxx'
                    "
                    [ngClass]="{
                      'rule-invalid': rulesSubmitAttempted && !isRuleRowValid(rule)
                    }"
                  />
                  <div *ngIf="rulesSubmitAttempted && !isRuleRowValid(rule)" class="rule-error-text">
                    {{ getRuleValidationMessage(rule) }}
                  </div>
                </td>
                <td class="rules-action-col">
                  <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeRule('outbound', rule)">
                    Remove
                  </button>
                </td>
              </tr>
              <tr *ngIf="outboundRules.length === 0">
                <td colspan="6" class="rules-empty-state">No outbound rules configured.</td>
              </tr>
            </tbody>
          </table>

          <div *ngIf="revokeOutboundRules.length" class="rules-revoke-section">
            <div class="rules-revoke-section__title">Queued for Revocation</div>
            <table class="table table-bordered rules-table">
              <thead>
                <tr>
                  <th>Protocol</th>
                  <th>From Port</th>
                  <th>To Port</th>
                  <th>Destination Type</th>
                  <th>Destination</th>
                  <th class="rules-action-col">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let rule of revokeOutboundRules" class="rule-revoke-row">
                  <td>{{ rule.protocol }}</td>
                  <td>{{ rule.from_port ?? "-" }}</td>
                  <td>{{ rule.to_port ?? "-" }}</td>
                  <td>{{ rule.target_type }}</td>
                  <td>{{ rule.target_value || "-" }}</td>
                  <td class="rules-action-col">
                    <button type="button" class="btn btn-light btn-sm" (click)="undoRemoveRule('outbound', rule)">
                      Undo
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="rules-modal__footer">
      <button type="button" class="btn btn-light" [disabled]="rulesSaving" (click)="closeRulesModal()">
        Cancel
      </button>
      <button type="button" class="btn btn-primary-soft" [disabled]="!canSaveRules()" (click)="saveRules()">
        <span *ngIf="rulesSaving">Saving...</span>
        <span *ngIf="!rulesSaving">Save Rules</span>
      </button>
    </div>
  </div>
</div>
